/**
 *
 * App.js
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 *
 */
import {Component} from "react";
import {Redirect, Route, Switch} from "react-router-dom";
import {MuiThemeProvider} from "@material-ui/core/styles";
import PrivateRoute from "utils/PrivateRoute";
import {ThemeProvider} from "styled-components";
import injectSaga from "utils/injectSaga";
import injectReducer from "utils/injectReducer";
import {compose} from "redux";
import TimeSlotPage from "containers/TimeSlotPage/Loadable";
import PracticePage from "containers/PracticePage/Loadable";
import DashboardPage from "containers/DashboardPage/DashboardPage";
import AuthorizationPage from "../AuthorizationPage/Loadable";
import UserEditPage from "../UserEditPage/UserEditPage";
import TimeSlotPlanner from "../TimeSlotPlanner/TimeSlotPlanner";
import AdminPage from "../AdminPage/Loadable";
import NewTreatmentPage from "../NewTreatmentPage/Loadable";
import PatientOverviewPage from "../PatientOverviewPage/PatientOverviewPage";
import saga from "./saga";
import reducer from "./reducer";
import GlobalStyle from "../../global-styles";
import {defaultMuiTheme, styling} from "styling";
import practicePageSaga from "../PracticePage/saga";
import practicePageReducer from "../PracticePage/reducer";
import DentistDataPage from "../DentistDataPage/Loadable";
import DentistOverviewPage from "../DentistOverviewPage/DentistOverviewPage";
import PageState from "../PageState/PageState";
import Order from "containers/Order/Loadable";
import DefaultProductSettingsPage from "containers/DefaultProductSettingsPage/Loadable";
import PatientOrderSummaryPage from "../PatientOrderSummary/Loadable";
import PracticeMessages from "containers/PracticeMessages/Loadable";
import PatientDataRouting from "containers/PatientDataPage";
import oauthcallback from "./oauthcallback"
import Threeshapelogout from "./threeshapelogout";

styling.init();

export class App extends Component {
  state = {
    theme: defaultMuiTheme,
  };

  render() {
    // ThemeProvider provides the theme to every styled component
    // MuiThemeProvider provides the theme to every @material component
    return (
      <PageState>
        <ThemeProvider theme={styling}>
          <MuiThemeProvider theme={this.state.theme}>
            <Switch>
              <Route path="/oauthcallback" component={oauthcallback}></Route>
              <Route path="/threeshapelogout" component={Threeshapelogout}></Route>
              <Route path="/login" component={AuthorizationPage} />
              <PrivateRoute
                exact
                path="/dashboard/practice"
                component={UserEditPage}
                needsPractice
              />
              <PrivateRoute
                exact
                path="/dashboard/practice/messages/:activeMessageId?"
                component={PracticeMessages}
                needsPractice
              />
              <PrivateRoute
                exact
                path="/dashboard/practice/product/defaults"
                component={DefaultProductSettingsPage}
                needsPractice
              />
              <PrivateRoute
                path="/dentists"
                component={DentistOverviewPage}
                needsPractice
              />
              <PrivateRoute
                path="/dentist/:dentistId"
                component={DentistDataPage}
                needsPractice
              />
              <PrivateRoute path="/practice" component={PracticePage} />
              <PrivateRoute
                path="/dashboard"
                component={DashboardPage}
                needsPractice
              />
              <PrivateRoute path="/admin" component={AdminPage} />
              <PrivateRoute path="/order" component={Order} needsPractice />
              <PrivateRoute
                path="/treatment/new/:patientId/:treatmentPlanId?/:plannedTreatment?"
                component={NewTreatmentPage}
                needsPractice
              />
              <PrivateRoute
                path="/treatment/edit/:patientId/:treatmentPlanId?/:plannedTreatment?"
                component={NewTreatmentPage}
                needsPractice
              />
              <PrivateRoute
                path="/patients"
                exact
                component={PatientOverviewPage}
                needsPractice
              />
              <PrivateRoute
                path="/timespan/plan/:timeSlotId?"
                component={TimeSlotPlanner}
                needsPractice
              />
              <PrivateRoute
                path="/timeslots/:date"
                component={TimeSlotPage}
                needsPractice
              />
              <PrivateRoute
                path="/patient/:id/order/:orderId"
                exact
                component={PatientOrderSummaryPage}
                needsPractice
              />
              <PrivateRoute path="" component={PatientDataRouting} />
              <Redirect to="/login" />
            </Switch>
            <GlobalStyle />
          </MuiThemeProvider>
        </ThemeProvider>
      </PageState>
    );
  }
}

const withReducer = injectReducer({ key: "app", reducer });
const withGlobalPracticePageReducer = injectReducer({
  key: "globalPracticePage",
  reducer: practicePageReducer,
});

const withSaga = injectSaga({ key: "app", saga });
const withGlobalPracticePageSaga = injectSaga({
  key: "globalPracticePage",
  saga: practicePageSaga,
});

export default compose(
  withReducer,
  withGlobalPracticePageReducer,

  withSaga,
  withGlobalPracticePageSaga,
)(App);
